<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><img alt="" height="100" src="images/logo-chicago-guides.jpg" width="147"/></p>
<p class="ser"><a class="page" id="pii"></a><i>Permissions, A Survival Guide</i></p>
<p class="serau">Susan M. Bielstein</p>
<p class="ser"><i>The Craft of Research</i></p>
<p class="serau">Wayne C. Booth, Gregory G. Colomb, Joseph M. Williams, Joseph Bizup, and William T. FitzGerald</p>
<p class="ser"><i>The Chicago Guide to Fact-Checking</i></p>
<p class="serau">Brooke Borel</p>
<p class="ser"><i>Writing Abroad</i></p>
<p class="serau">Peter Chilson and Joanne B. Mulcahy</p>
<p class="ser"><i>Immersion</i></p>
<p class="serau">Ted Conover</p>
<p class="ser"><i>The Art of Creative Research</i></p>
<p class="serau">Philip Gerard</p>
<p class="ser"><i>Getting It Published</i></p>
<p class="serau">William Germano</p>
<p class="ser"><i>What Editors Do</i></p>
<p class="serau">Peter Ginna, editor</p>
<p class="ser"><i>Storycraft</i></p>
<p class="serau">Jack Hart</p>
<p class="ser"><i>Behind the Book</i></p>
<p class="serau">Chris Mackenzie Jones</p>
<p class="ser"><i>A Poet’s Guide to Poetry</i></p>
<p class="serau">Mary Kinzie</p>
<p class="ser"><i>Developmental Editing</i></p>
<p class="serau">Scott Norton</p>
<p class="ser"><i>The Subversive Copy Editor</i></p>
<p class="serau">Carol Fisher Saller</p>
<p class="ser"><i>The Writer’s Diet</i></p>
<p class="serau">Helen Sword</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-friedman-0003.vue?a3567ea6